import { connect } from 'react-redux';
import SetupMfa from './SetupMfa';
import { 
    resetLoginActionsRequest 
} from '../../../store/actions/auth.actions';

import {
    mfaSetupRequired,
    mfaSetupToken as mfaSetupTokenData,
} from '../../../store/selectors/auth.selector';

const mapDispatchToProps = { resetLoginActionsRequest };

const mapStateToProps = (state) => {
    const isMfaSetupRequired = mfaSetupRequired(state);
    const mfaSetupToken = mfaSetupTokenData(state);
    return { isMfaSetupRequired, mfaSetupToken };
};

export default connect(mapStateToProps, mapDispatchToProps)(SetupMfa);